import {StatusDTO} from "./statusDTO.interface";

export interface BaseIntDTO {
  id?: number;
  statusId?: number;
  status?: StatusDTO;
  added?: Date;
  updated?: Date;
}
